import {
  GENERATE_AI_SUGGESTIONS,
  FETCH_AI_SUGGESTIONS,
  FETCH_AI_SUGGESTIONS_SUCCESS,
  FETCH_AI_SUGGESTIONS_FAILURE,
  ACCEPT_AI_SUGGESTION,
  DISMISS_AI_SUGGESTION,
} from "./constants";

/**
 * Generate + persist pending AI suggestions for a care plan (does NOT create real
 * records). Spends a care_planning credit. Soft-fails (ai_unavailable) like the
 * co-writer.
 * @param {{residentId:string, templateId:string, carePlanId:string, target:'schedule'|'equipment', locationId?:(number|string)}} payload
 */
export const generateAiSuggestions = (payload, onSuccess, onError) => ({
  type: GENERATE_AI_SUGGESTIONS,
  payload,
  onSuccess,
  onError,
});

/**
 * Fetch the still-pending suggestions for a care plan + target.
 * @param {{residentId:string, carePlanId:string, target:'schedule'|'equipment'}} payload
 * @param {(items:Array)=>void} [onSuccess]
 */
export const fetchAiSuggestions = (payload, onSuccess, onError) => ({
  type: FETCH_AI_SUGGESTIONS,
  payload,
  onSuccess,
  onError,
});

export const fetchAiSuggestionsSuccess = (payload) => ({
  type: FETCH_AI_SUGGESTIONS_SUCCESS,
  payload,
});

export const fetchAiSuggestionsFailure = (payload) => ({
  type: FETCH_AI_SUGGESTIONS_FAILURE,
  payload,
});

/** Accept one → replayed into a real schedule/task/equipment record. */
export const acceptAiSuggestion = (payload, onSuccess, onError) => ({
  type: ACCEPT_AI_SUGGESTION,
  payload,
  onSuccess,
  onError,
});

/** Dismiss one. */
export const dismissAiSuggestion = (payload, onSuccess, onError) => ({
  type: DISMISS_AI_SUGGESTION,
  payload,
  onSuccess,
  onError,
});
